import { render, staticRenderFns } from "./ExpenseDetails.vue?vue&type=template&id=f1119800&scoped=true&"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetails.vue?vue&type=style&index=0&id=f1119800&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1119800",
  null
  
)

export default component.exports